var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "box-chat position-relative" },
    [
      _c(
        "div",
        { staticClass: "position-absolute w-100 h-100 d-flex flex-column" },
        [
          _c(
            "div",
            {
              ref: "messageContainer",
              staticClass:
                "box-body flex-grow-1 overflow-auto word-break-normal",
            },
            [
              _c(
                "infinite-loading",
                {
                  attrs: { direction: "top", spinner: "waveDots" },
                  on: { infinite: _vm.loadMessages },
                  scopedSlots: _vm._u([
                    {
                      key: "error",
                      fn: function ({ trigger }) {
                        return [
                          _c("h5", [
                            _c("span", { staticClass: "badge badge-danger" }, [
                              _vm._v(
                                "Whoops. It looks like the server is unavailable."
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return trigger()
                                    },
                                  },
                                },
                                [_vm._v("Retry")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _c("template", { slot: "no-more" }, [
                    _c("h5", [
                      _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v("Beginning of the conversation"),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("template", { slot: "no-results" }, [
                    _c("h5", [
                      _c("span", { staticClass: "badge badge-secondary" }, [
                        _vm._v("There are no messages yet"),
                      ]),
                    ]),
                  ]),
                ],
                2
              ),
              _vm._v(" "),
              _vm._l(_vm.messages, function (message) {
                return _c(_vm.getMessageComponentName(message), {
                  key: message.id,
                  tag: "component",
                  attrs: {
                    message: message,
                    contact: _vm.contact,
                    "outgoing-number": _vm.outgoingNumber,
                    brand: _vm.brand,
                    settings: _vm.getMessageSettings,
                    "email-message-settings": _vm.getEmailMessageSettings,
                    "email-address": _vm.getEmailAddress,
                  },
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _vm.havePendingMessage
            ? _c("div", { staticClass: "wrapper w-100 schedule__link" }, [
                _c(
                  "a",
                  {
                    staticClass: "cursor-pointer",
                    on: { click: _vm.showScheduleList },
                  },
                  [
                    _c("i", { staticClass: "far fa-clock" }),
                    _vm._v(" See all scheduled messages"),
                  ]
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("send-box", {
            ref: "sendBox",
            staticClass: "flex-shrink-0 flex-grow-0 mt-2",
            attrs: {
              brand: _vm.brand,
              types: _vm.types,
              conversation: _vm.conversation,
              styles: _vm.styles,
            },
            on: { "outbound-message-created": _vm.refresh },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("media-dialog"),
      _vm._v(" "),
      _c("attachment-dialog", {
        attrs: {
          "index-media-url": _vm.indexMediaUrl,
          "store-media-url": _vm.storeMediaUrl,
          "can-create-media": _vm.canCreateMedia,
        },
      }),
      _vm._v(" "),
      _c("attachment-form"),
      _vm._v(" "),
      _c("edit-message-form", { on: { stored: _vm.updateMessage } }),
      _vm._v(" "),
      _c("dialog-edit-contact", {
        attrs: { "conversation-id": _vm.conversation.id },
      }),
      _vm._v(" "),
      _c("schedule-dialog", {
        attrs: {
          "pending-message-index-url": _vm.getPendingMessageIndexUrl,
          "store-pending-message-url": _vm.getStorePendingMessageUrl,
        },
        on: { stored: _vm.onStoredScheduleMessage },
      }),
      _vm._v(" "),
      _c("original-email-message"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }